// components/layout/Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="copyright">
        © 2025 Tinubu Ambode Supporters. All rights reserved
      </p>
    </footer>
  );
};

export default Footer;